/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */
import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { getActiveInteraction } from '@atlaskit/react-ufo/interaction-metrics';
import traceUFOInteraction from '@atlaskit/react-ufo/trace-interaction';
import { expValEquals } from '@atlaskit/tmp-editor-statsig/exp-val-equals';
export var traceUFOInteractionOnFirstInteraction = function traceUFOInteractionOnFirstInteraction() {
  var aborted = false;
  function abortIfNotAborted(event) {
    if (aborted) {
      // opt out of additional logic if already aborted
      return;
    }
    var activeInteraction = getActiveInteraction();
    if (activeInteraction && ['edit-page', 'live-edit'].includes(activeInteraction.ufoName)) {
      traceUFOInteraction('new_interaction', event);
    }
    aborted = true;
  }
  return new SafePlugin({
    props: {
      handleDOMEvents: {
        mouseover: function mouseover(_view, event) {
          if (expValEquals('cc_editor_interactions_trigger_traceufointeraction', 'cohort', 'only_mousedown_event')) {
            return;
          }
          abortIfNotAborted(event);
        },
        mouseenter: function mouseenter(_view, event) {
          if (expValEquals('cc_editor_interactions_trigger_traceufointeraction', 'cohort', 'only_mousedown_event')) {
            return;
          }
          abortIfNotAborted(event);
        },
        mousedown: function mousedown(_view, event) {
          return abortIfNotAborted(event);
        }
      }
    }
  });
};